// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid-stack {
  margin-bottom: 0;
  margin-top: 0;
}

#tab-menu {
  height: 20px;
  color: #888;
  width: 16px;
  text-align: center;
}

.tabs-container {
  display: flex;
  flex-direction: row;
}

.spacer {
  flex-grow: 1;
}

ul.tabs {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #333;
}

/* Float the list items side by side */
ul.tabs li {
  float: left;
  line-height: 1;
  height: 100%;
}

/* Style the links inside the list items */
ul.tabs li a {
  display: inline-block;
  color: dimgray;
  text-align: center;
  text-decoration: none;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  transition: 0.3s;
  font-size: 12px;
  border-color: dimgray;
  border-top: 1px solid;
  border-left: 1px solid;
  border-right: 1px solid;
  margin-right: 5px;
  border-radius: 5px 5px 0 0;
  height: 100%;
}

ul.tabs li:first-of-type a {
  margin-left: 5px;
}

/* Change background color of links on hover */
ul.tabs li a:hover {
  background-color: #333;
}

/* Create an active/current tablink class */
ul.tabs li a.active {
  background-color: #555;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/tabs/styles.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,YAAY;AACd","sourcesContent":[".grid-stack {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n\n#tab-menu {\n  height: 20px;\n  color: #888;\n  width: 16px;\n  text-align: center;\n}\n\n.tabs-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.spacer {\n  flex-grow: 1;\n}\n\nul.tabs {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: #333;\n}\n\n/* Float the list items side by side */\nul.tabs li {\n  float: left;\n  line-height: 1;\n  height: 100%;\n}\n\n/* Style the links inside the list items */\nul.tabs li a {\n  display: inline-block;\n  color: dimgray;\n  text-align: center;\n  text-decoration: none;\n  padding-left: 5px;\n  padding-right: 5px;\n  padding-top: 3px;\n  transition: 0.3s;\n  font-size: 12px;\n  border-color: dimgray;\n  border-top: 1px solid;\n  border-left: 1px solid;\n  border-right: 1px solid;\n  margin-right: 5px;\n  border-radius: 5px 5px 0 0;\n  height: 100%;\n}\n\nul.tabs li:first-of-type a {\n  margin-left: 5px;\n}\n\n/* Change background color of links on hover */\nul.tabs li a:hover {\n  background-color: #333;\n}\n\n/* Create an active/current tablink class */\nul.tabs li a.active {\n  background-color: #555;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
